import { render, staticRenderFns } from "./DressCard.vue?vue&type=template&id=4e1a51c6&scoped=true&"
import script from "./DressCard.vue?vue&type=script&lang=ts&"
export * from "./DressCard.vue?vue&type=script&lang=ts&"
import style0 from "./DressCard.vue?vue&type=style&index=0&id=4e1a51c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a51c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VImg})
